module.exports = __webpack_public_path__ + "static/media/status-completed.f3ab2d26.svg";